/**
 * Max length after an unclosed `{{` to still treat it as an incoming citation id. Beyond it, show
 * the text rather than hide the rest of the response.
 */
const MAX_CITATION_MARKER_LENGTH = 64;

/**
 * Hides a citation marker still streaming in (`{{` without `}}`). Complete markers are left for `ChatMessage`.
 */
export const hideUnterminatedCitationMarker = (content: string): string => {
  const openIndex = content.lastIndexOf('{{');
  if (openIndex === -1) return content;
  if (content.includes('}}', openIndex)) return content;
  if (content.length - openIndex > MAX_CITATION_MARKER_LENGTH) return content;
  return content.slice(0, openIndex);
};
